import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import React, { useRef} from "react";
import { usePresentacionContext } from "../context/presentacion.context";
import { Impuesto } from "../models/Impuesto.model";
import { consultarImpuestosPredeterminados } from "../services/impuestos.service";
import { NumericFormat } from "react-number-format";
import { useGlobalContext } from "../../shared/context/global.context";
import { Toast } from "primereact/toast";
import { comprobantesProcess } from "../utilities/comprobantes";
import { INICIADA_COMERCIO, RECHAZADA } from "../utilities/constants";

interface Props {
  onClick: Function;
}

const ImpuestosTasasDatatable = (props: Props) => {
  const { userSessionModulo } = useGlobalContext();
  const {
    setImpuestoTasaSeleccionado,
    setOnHideDialog,
    spinnerImpuestosTasas,
    dataImpuestos,
    comprobantes,
    presentacionEditable,
    flagUpdateTableImpuestosTasas,
    setFlagUpdateTableImpuestosTasas,
    presentacionState
  } = usePresentacionContext();
    const toast = useRef<Toast>(null);

  const onClickEdit = async (rowData: any) => {
    if(!userSessionModulo){
      toast.current?.show({life: 5000, severity: 'error', summary: 'Message', detail: `No tiene habilitado el permiso para la carga de impuesto Manual`});
    }else{
      let resultImpuestosPredeterminados = await consultarImpuestosPredeterminados()
      if(resultImpuestosPredeterminados.data.impuestos.length > 0){
        let filterImpuestos = resultImpuestosPredeterminados.data.impuestos.filter((impuesto:any)=>{
          return impuesto.idServicio == rowData.idServicio
        })
        if(filterImpuestos.length > 0 && rowData.precioIDC == 0 && rowData.precioITC == 0){
          let rowDataCopy = Object.assign({} , rowData)
          rowDataCopy.precioIDC = filterImpuestos[0].precioIDC;
          rowDataCopy.precioITC = filterImpuestos[0].precioITC;
          rowDataCopy.precioTasaHidrica = filterImpuestos[0].precioTasaHidrica;
          rowDataCopy.precioTasaMunicipal = filterImpuestos[0].precioTasaMunicipal;
          rowDataCopy['impuestoPredeterminado'] = true;
          setImpuestoTasaSeleccionado(rowDataCopy);
        }else{
          setImpuestoTasaSeleccionado(rowData);
        }
      }else{
        setImpuestoTasaSeleccionado(rowData);
      }
      setOnHideDialog(true);
    }
    
  };

  const actionBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        <span className="p-column-title">Declarar</span>
        <Button
          className="p-button-rounded p-button-text"
          aria-label="Filter"
          onClick={() => onClickEdit(rowData)}
          tooltip="Editar"
        >
          <i className="pi pi-pencil mr-2"></i>
        </Button>
      </React.Fragment>
    );
  };
  const declaradoBodyTemplate = (rowData: Impuesto) => {
    return (
      <React.Fragment>
        {rowData.declarado ? (
          <Button
            className="p-button-rounded p-button-text"
            aria-label="Filter"
            tooltip="Declarado"
            onClick={() => "return false;"}
          >
            <i
              className="pi pi-verified mr-2"
              style={{ fontSize: "1.5em", color: "var(--green-300)" }}
            ></i>
          </Button>
        ) : (
          <Button
            className="p-button-rounded p-button-text"
            aria-label="Filter"
            tooltip="No Declarado"
            onClick={() => "return false;"}
          >
            <i
              className="pi pi-ban mr-2"
              style={{ fontSize: "1.5em", color: "#e91224" }}
            />
          </Button>
        )}
      </React.Fragment>
    );
  };

  const formatMoneyBodyTemplate = (monto: any) => {
    return (
      <React.Fragment>
        {/*<span className="p-column-title">`${title}`</span>*/}
        <NumericFormat
          value={monto}
          displayType={"text"}
          thousandSeparator={"."}
          decimalSeparator={","}
          prefix={"$"}
          decimalScale={4}
          fixedDecimalScale={true}
        />
      </React.Fragment>
    );
  };

    let sumTotalImpuestos: number = comprobantesProcess(comprobantes).sumatoriaDeImpuestos;
    let totales =
        [
            {
                headerTitle: "Total Declarado",
                totalPrecioITC: dataImpuestos.totalGeneralITC,
                totalPrecioIDC: dataImpuestos.totalGeneralIDC,
                totalTasaMunicipal: dataImpuestos.totalGeneralTasaMunicipal,
                totalTasaHidrica: dataImpuestos.totalGeneralTasaHidrica,
                total: dataImpuestos.totalGeneral
            },
            {
                headerTitle: "Total Facturado",
                total: sumTotalImpuestos
            },
            {
                headerTitle: "Diferencia",
                total: dataImpuestos.totalGeneral - sumTotalImpuestos
            }
        ];

    const renderHeader = () => {
        return (
            presentacionState === INICIADA_COMERCIO || presentacionState === RECHAZADA
                ? (
                    <div className="p-grid p-justify-between p-align-center">
                        <div className="p-col-12 p-md-6" style={{ textAlign: "left" }}>
                        </div>
                        <div className="p-col-12 p-md-6" style={{ textAlign: "end" }}>
                            <div className="table-header-container">
                                <div className="button-demo">
                                    <div className="template">
                                        <Button
                                            className="eden-clr-blue p-0"
                                            aria-label="Actualizar"
                                            onClick={() => updateImpuestosTasasDataTable()}
                                        >
                                            <i className="pi pi-refresh px-2"></i>
                                            <span className="px-3">Actualizar</span>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                ) : null
        );
    };

    const updateImpuestosTasasDataTable = () => {
        setFlagUpdateTableImpuestosTasas(flagUpdateTableImpuestosTasas + 1);
    }

    return (
        <>
            <Toast ref={toast} position="bottom-right" />
            <DataTable
                header={renderHeader()}
                value={dataImpuestos.impuestos}
                responsiveLayout="stack"
                className="txDataTable"
                size="small"
                loading={spinnerImpuestosTasas}
            >
                <Column
                    field="servicioXBandera"
                    header="Producto"
                    style={{ width: "12%" }}
                />
                <Column
                    field="litros"
                    header="Litros"
                    style={{ textAlign: "right", width: "12%" }}
                />
                <Column
                    field="precioITC"
                    body={(rowData) => formatMoneyBodyTemplate(rowData.precioITC)}
                    header="ITC"
                    headerTooltip="Impuesto a la transferencia combustible"
                    style={{ textAlign: "right", width: "12%" }}
                    headerTooltipOptions={{ position: 'top' }}
                />
                <Column
                    field="precioIDC"
                    body={(rowData) => formatMoneyBodyTemplate(rowData.precioIDC)}
                    header="IDC"
                    headerTooltip="Impuesto al Dióxido de Carbono"
                    style={{ textAlign: "right", width: "12%" }}
                    headerTooltipOptions={{ position: 'top' }}
                />
                <Column
                    field="precioTasaMunicipal"
                    header="Tasa municipal"
                    body={(rowData) =>
                        formatMoneyBodyTemplate(rowData.precioTasaMunicipal)
                    }
                    style={{ textAlign: "right", width: "12%" }}
                ></Column>
                <Column
                    field="precioTasaHidrica"
                    header="Otras tasas"
                    body={(rowData) =>
                        formatMoneyBodyTemplate(rowData.precioTasaHidrica)
                    }
                    style={{ textAlign: "right", width: "12%" }}
                    headerTooltip="Tasa Hídrica y Fondo Fiduciario la suma de ambas tasas se debe informar en Otras Tasas"
                    headerTooltipOptions={{ position : 'top' }}
                />
                <Column
                    field="totalServicio"
                    header={<span style={{ textAlign: "center" }}>Total</span>}
                    body={(rowData) => formatMoneyBodyTemplate(rowData.totalServicio)}
                    style={{ textAlign: "right", width: "12%" }}
                />
                <Column
                    field="declarado"
                    header="Estado"
                    body={declaradoBodyTemplate}
                    style={{ width: "5%" }}
                />
                <Column
                    rowEditor
                    header="Editar"
                    body={actionBodyTemplate}
                    style={{ width: "12%" }}
                    hidden={!presentacionEditable}
                />
            </DataTable>
            {!spinnerImpuestosTasas && <DataTable
                //footer={()=>renderFooter()}
                value={totales}
                responsiveLayout="stack"
                size="small"
                rowClassName={(row) => { return { 'row-diferencia': row.headerTitle === 'Diferencia' } }}
                loading={spinnerImpuestosTasas}
            >
                <Column field="headerTitle" style={{ width: "12%" }} />
                <Column style={{ textAlign: "right", width: "12%" }} />
                <Column
                    field="totalPrecioITC"
                    style={{ textAlign: "right", width: "12%" }}
                    body={(rowData) => formatMoneyBodyTemplate(rowData.totalPrecioITC)}
                />
                <Column
                    field="totalPrecioIDC"
                    style={{ textAlign: "right", width: "12%" }}
                    body={(rowData) => formatMoneyBodyTemplate(rowData.totalPrecioIDC)}
                />
                <Column
                    field="totalTasaMunicipal"
                    style={{ textAlign: "right", width: "12%" }}
                    body={(rowData) => formatMoneyBodyTemplate(rowData.totalTasaMunicipal)}
                ></Column>
                <Column
                    field="totalTasaHidrica"
                    style={{ textAlign: "right", width: "12%" }}
                    body={(rowData) => formatMoneyBodyTemplate(rowData.totalTasaHidrica)}
                />
                <Column
                    field="totalGeneral"
                    style={{ textAlign: "right", width: "12%" }}
                    body={(rowData) => formatMoneyBodyTemplate(rowData.total)}
                />
                <Column style={{ width: "5%" }} />
                <Column style={{ width: "12%" }} hidden={!presentacionEditable} />
            </DataTable>}
        </>
    );
};

export default ImpuestosTasasDatatable;
